import { createContext, useContext } from "react";

import useUsersCompany from "../hooks/useUsersCompany";

import { AuthContext } from "./AuthContext";
import Loader from "../components/Loader";

export const PartnerContext = createContext();

export const PartnerProvider = ({ children }) => {
  const { user } = useContext(AuthContext);

  const { data, isLoading, mutate } = useUsersCompany({
    shouldFetch: !!user,
    userId: user?._id
  });

  const partnerCompany = data?.company;

  return (
    <PartnerContext.Provider value={{
      partnerCompany,
      loading: isLoading,
      mutatePartnerCompany: mutate
    }}>
      {isLoading && (
        <div className="fixed t-0 r-0 b-0 l-0 z-50 flex items-center justify-center bg-white w-screen h-screen">
          <Loader />
        </div>
      )}

      <div className="bg-slate-50 min-h-screen">
        {!isLoading && children}
      </div>
    </PartnerContext.Provider>
  )
};

export default PartnerContext;
